import {treeDef} from './treeDef'
import {basic} from 'basic'
import { tree } from '../genealogy';
import {useState,useEffect,useContext} from 'react'
import Person from 'person/person'
import Generation from 'generation/generation'
import {listProvinces,minYear,backEndGeneo,showError,client} from './treeProvider'
import css from './tree.module.css'
import 'geneoStyle.css'
import { useNavigate,useLocation } from "react-router-dom";
import {Langue} from '../context'
import Text from 'text/text'
import {wrMsg} from 'utile'

const provincesFR=[
    "Alberta",
    "Colombie-Britannique",
    "Île-du-Prince-Édouard",
    "Manitoba",
    "Nouveau-Brunswick",
    "Nouvelle-Écosse",
    "Ontario",
    "Québec",
    "Saskatchewan",
    "Terre-Neuve-et-Labrador"
  ];

  async function sendTree(arbre:tree.geneo,backEnd:string,mail:string,langue:string,addr:tree.Address):Promise<{status:string,transaction:string}>
  {
      try{
          const gen=tree.convert(arbre,addr)
     
          
          const response = await fetch(backEnd+`geneo/submit`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({...gen,mail,langue}),
            });
        
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data=await response.json() as any
          const {status,transaction}=data
          return {status,transaction}
       
      }catch(error)
      {
          console.log(error)
          debugger
          throw error
      }
  }

function validateTree(gen:tree.FamilyGen,lastYear:number|null,minYear:number):tree.FamilyGen
{   
    try{
        let split=gen.date.split("-")
        const year=parseInt(split[0])
        gen.erreur=null

        if(isNaN(year))
        {
            return {...gen,erreur:"date"};
        }
        if(lastYear!==null)
            if(year>=lastYear)
                return {...gen,erreur:"date"};

        if(year<minYear && lastYear!==null)
        {
            gen.paternel=null;
            gen.maternel=null;
        }

        if(gen.city.trim().length==0)
            return {...gen,erreur:"ville"};
        const {man,woman}=gen
        if(man.firstName.trim().length==0)
            return {...gen,erreur:"person",man:{...man,erreur:"prenom"}};
        if(man.name.trim().length==0)
            return {...gen,erreur:"person",man:{...man,erreur:"nom"}};
           
        if(woman.firstName.trim().length==0)
            return {...gen,erreur:"person",woman:{...woman,erreur:"prenom"}};
        if(woman.name.trim().length==0)
            return {...gen,erreur:"person",woman:{...woman,erreur:"nom"}};
       
        let newGen=false
        if(gen.paternel)
        {
            const pastGen=validateTree(gen.paternel,year,minYear)
            if(pastGen.erreur)
                return {...gen,erreur:"erreur",paternel:pastGen}
            gen={...gen,erreur:null,paternel:pastGen};
        }else if(year>minYear)
        {
            gen={...gen,erreur:"erreur",paternel:tree.emptyFam({paternel:null,maternel:null})}
            newGen=true
        }
           
        if(gen.maternel)
        {
            const pastGen=validateTree(gen.maternel,year,minYear)
            if(pastGen.erreur)
                return {...gen,erreur:"erreur",maternel:pastGen}
            gen={...gen,erreur:null,maternel:pastGen};
        }else if(year>minYear)
        {
            gen={...gen,erreur:"erreur",maternel:tree.emptyFam({paternel:null,maternel:null})}
            newGen=true
        }

        if(newGen)
            return gen

        return {...gen,erreur:null,man:{...man,erreur:null},woman:{...woman,erreur:null}}
    }catch(erreur)
    {
        console.log(erreur)
        debugger;
        throw erreur
    }
}

function checkAmmeMariage(gen:tree.FamilyGen,minYear:number)
{
    try{
        const split=gen.date.split("-")
        const year=parseInt(split[0])
        if(isNaN(year))
        {
            return false
        }
        if(year<=minYear)
            return true
        const {paternel,maternel}=gen;
        if(paternel)
        {
            if(checkAmmeMariage(paternel,minYear))
                return true
        }

        if(maternel)
        {
            if(checkAmmeMariage(maternel,minYear))
                return true
        }
        return false
    }catch(error)
    {
        console.log(error)
        debugger;
        throw error
    }
}

function checkAnneMariages(p:{paternel:tree.FamilyGen,maternel:tree.FamilyGen,minYear:number})
    {
        try{
            const {paternel,maternel,minYear}=p
            if(!checkAmmeMariage(paternel,minYear) ||
                !checkAmmeMariage(maternel,minYear))
            {
                return false
              
            }
            return true
        }catch(error)
        {
            console.log(error)
            debugger;
            throw error
        }
    }

export default function Tree(props:treeDef.props)
{
    const [className,style]=basic.getBasic(props)
    const [arbre,setArbre]=useState(tree.emptyTree())
    const [addr,setAddr]=useState<tree.Address>(tree.emptyAddr())
    // const [minimumYear,setMinimumYear]=useState(0)
    // const [backEnd,setBackEnd]=useState("")
    //const [arbreOk,setArbreOk]=useState(false)
    const [seeError,setSeeError]=useState(false)
    const [erreur,setErreur]=useState<null|string>(null)
    const [mail,setMail]=useState("")
    const [validMail,setvalidMail]=useState(false)
   // const [provinces,setProvinces]=useState<string[]>([])
    const [waiting,setWaiting]=useState(false)
    const navigate = useNavigate();

    const location=useLocation()
    
    const params = new URLSearchParams(location.search);
    const language = params.get("langue");
    const [langue, setLng] = useState(language && language.toLocaleLowerCase()=="en"?"EN":"FR");
    
    
    const backEnd=useContext(backEndGeneo)
    const minimumYear=useContext(minYear)
    const clientGeneo=useContext(client)

 

    //const langue=useContext(Langue)

    /*
        develop child ++gp
        focus/unfocus branche on click ++gp
        --1917 add
        1917++ del
        child voisin
    */

    


   /* function onTreeChange(arbre:tree.geneo)
    {
        try{
            
            setArbre({...arbre})
        }catch(error)
        {
            console.log(error)
            debugger
        }
    }*/

    interface Config {
        geneoMinYear:number,
        backEndGeneo:string
    }
      
    // async function loadConfig()
    // {
    //     try{
    //         const res = await fetch("/config.json");
            
    //         if (!res.ok) {
    //             debugger
    //             throw new Error("Failed to load config");
    //         }
            
    //         const {geneoMinYear,backEndGeneo}= await res.json();
    //         setMinimumYear( geneoMinYear)
    //         setBackEnd(backEndGeneo)
    //     }catch(error)
    //     {
    //         console.log(error)
    //         debugger;
    //         throw error
    //     }
    // }

  
    function firstGens(arbre:tree.geneo):{parents:tree.FamilyGen,maternel:tree.FamilyGen,paternel:tree.FamilyGen}
    {
        try{
            const {parents}=arbre
            const {maternel,paternel}=parents

            if(!maternel || !paternel)
                throw "null grant-parents"

            return {parents,maternel,paternel}
        }catch(error)
        {
            debugger;
            console.log(error)
            throw error
        }
    }

    const validateEmail = (email: string)=> {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const rep=emailRegex.test(email)
        setvalidMail(rep)
        return rep
    };

    function isValidAddress(address: tree.Address){
        if (!address || typeof address !== 'object') {
          return false;
        }
      
        const { province, city, postalCode, streetAddress } = address;
      
        // Check if each property exists and is a non-empty string.
        if (typeof province !== 'string' || province.trim().length === 0) return false;
        if (typeof city !== 'string' || city.trim().length === 0) return false;
        if (typeof postalCode !== 'string' || postalCode.trim().length === 0) return false;
        if (typeof streetAddress !== 'string' || streetAddress.trim().length === 0) return false;
      
        // Optional: add further validations (e.g., regex for postalCode)
        // const postalCodeRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
        // if (!postalCodeRegex.test(postalCode)) return false;
      
        return true;
      }

    function validateAll():boolean
    {
        try{
            if(!isValidAddress(addr))
                return false
            if(!validateEmail(mail))
                return false
            
            if(firstGenLoseFocus())
                return false
                
            

            const gens=validateTree(arbre.parents,null,minimumYear)
            setArbre({...arbre,parents:gens})
            if(gens.erreur)
            {
                //setSeeError(true)
                return false
            }
            return true
            //setArbreOk(gen.erreur===null)
        }catch(error)
        {
            debugger;
            console.log(error)
            throw error
        }
    }

    function onGenerationLoseFocus()
    {
        try{
            validateAll()
           
            //setArbreOk(gen.erreur===null)
        }catch(error)
        {
            debugger;
            console.log(error)
            throw error
        }
    }

    function firstGenLoseFocus()
    {
        const {owner}=arbre
            const {name,firstName}=owner;
            if(name.trim().length==0)
            {
                setArbre({...arbre,owner:{...owner,erreur:"nom"}})
                setSeeError(true) 
                return true
            }
            if(firstName.trim().length==0)
            {
                setArbre({...arbre,owner:{...owner,erreur:"prenom"}})
                setSeeError(true) 
                return true
            }

            return false
    }

    async function sendClick()
    {
        try{
           if(!validateAll())
            return
            if(!checkAnneMariages({paternel,maternel,minYear:minimumYear}))
            {
                setErreur(wrMsg(`Nous avons besoin de mariages datant d'au moin ${minimumYear}`,`We need weddings form ${minimumYear} or older`,langue))
                return
            }
            setErreur(null)
            setSeeError(false)
          //  setWaiting(true)

            

            const rep=await sendTree(arbre,backEnd,mail,langue,addr)
            if(rep.status=="invalid")
            {
                setErreur(wrMsg("Arbre non conforme","Bad tree",langue))
                return;
            }
            if(rep.status=="en_cours")
            {
                setErreur(wrMsg("Vous avez deja une genealogie en traitement","We are already processing a genealogy from you",langue))
                return;
            }
            navigate(clientGeneo+`transaction/${rep.transaction}?langue=${langue}`);

        }catch(error)
        {
            debugger;
            console.log(error)
            alert('erreur');
        }
    }



    const {maternel,paternel,parents}=firstGens(arbre)
    const mailChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMail(event.target.value);
      };

      const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setAddr(prev => ({
          ...prev,
          [name]: value
        }));
      };

    return (
        <Langue.Provider value={langue}>
            <div className={`${className} ${css.tree} reactGen`} style={{...style}}>
                {waiting?
                <div className="waitingContainer">
                        <div className="waitingBox"></div>
                </div>:
                <>
                
                    <div className="gAdresse">
                        <Text fr={["Adresse"]} en={["Address"]} className="gAdressTitre"/>
                        <Text fr={["Rue"]} en={["street"]} />
                        <input
                            id="street"
                            type="text"
                            name="streetAddress"
                            value={addr.streetAddress}
                            onChange={handleChange}
                        />
                        
                
                        <Text fr={["Ville"]} en={["City"]} className="gAdresseLabel"/>
                        <input
                            id="city"
                            type="text"
                            name="city"
                            value={addr.city}
                            onChange={handleChange}
                        />
                        
                        <div  className="gAdresseLabel">
                            Province
                        </div>
                        <select name="province" 
                                    value={addr.province} 
                                    onChange={handleChange}
                                >
                                {
                                    provincesFR.map(function(value,index){
                                        return <option key={index} value={value}>{value}</option>
                                    })
                                }
                        
                        </select>
                    
                        <Text fr={["Code Postal"]} en={["Postal code"]}  className="gAdresseLabel"/>
                        <input
                            id="zip"
                            type="text"
                            name="postalCode"
                            value={addr.postalCode}
                            onChange={handleChange}
                        />
              
                    </div>
          
                    <div className="iAm">
                        <div className="gText">
                            <Text fr={["Je suis"]} en={["I am"]}/>
                        </div>
                        <Person value={arbre.owner} 
                                className="owner"
                                onChange={(p:{name:string,firstName:string})=>setArbre({...arbre,owner:{...p,erreur:null}})}
                                onLoseFocus={onGenerationLoseFocus}/>
                        <div className="gMail">
                            <label htmlFor="email">Email:</label>
                            <input
                                type="email"
                                id="email"
                                value={mail}
                                onChange={mailChanged}
                                placeholder="Email"
                                onBlur={onGenerationLoseFocus}
                            
                            />
                     
                        </div>
                    </div>
                    
                    <showError.Provider value={seeError}>
                     
                            <listProvinces.Provider value={provincesFR}>
                                              
                                    <Generation generation={parents} text={wrMsg("Mes parents sont","My parents are",langue)} 
                                                numGen={2}
                                                onGenChange={(gen)=>setArbre({...arbre,parents:gen})}
                                                voirNumGen={true}
                                                className="gen1"
                                                onLoseFocus={onGenerationLoseFocus} />
                                    <Generation generation={paternel} text={wrMsg("Mes Grand-parents Paternel sont","My paternal grand-parents are",langue)} 
                                                develop={true}
                                                onGenChange={(gen)=>setArbre({...arbre,parents:{...parents,paternel:gen}})}
                                                numGen={3}
                                                className="gen2"
                                                voirNumGen={true}
                                                onLoseFocus={ onGenerationLoseFocus}/>
                                    <Generation generation={maternel} text={wrMsg("Mes Grand-parents Maternel sont","My maternal grand parents are",langue)} 
                                                develop={true}
                                                onGenChange={(gen)=>setArbre({...arbre,parents:{...parents,maternel:gen}})}
                                                numGen={3}
                                                className="gen3"
                                                voirNumGen={true}
                                                onLoseFocus={onGenerationLoseFocus} />
                                
                            </listProvinces.Provider>
                      
                    </showError.Provider>
                    {
                        erreur?
                        <div className={`${css.erreur}`}>
                            {erreur}
                        </div>:null
                    }
                    <button disabled={parents.erreur!==null || arbre.owner.erreur!==null || !validMail} onClick={sendClick} className="btnSend">
                        <Text fr={["Envoyer"]} en={["Send"]}/>
                    </button>
                </>
        }
            </div></Langue.Provider>)
   
}